// extracted by mini-css-extract-plugin
export default {"herodiv":"Hero_herodiv__wGh-k"};